import { SVGProps } from 'react';

import palette from '../../../theme/learnerPalette';
import { styleConfigs } from '../../resources/styleConfigs';

const GraduateOwlIcon = ({
  width = styleConfigs.dimensions.width120,
  height = styleConfigs.dimensions.height120,
  stroke = palette.light.icons.prussianBlue,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.0477 29.2516L94.8893 19.7356L60.0477 10.2329C58.8995 9.92219 57.6894 9.92219 56.5413 10.2329L21.6553 19.7356L56.5191 29.2471C57.6738 29.5634 58.8921 29.5649 60.0477 29.2516Z"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M81.5762 38.173V23.3752" stroke={stroke} strokeWidth={4} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M38.3018 24.2806V36.8103" stroke={stroke} strokeWidth={4} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21.6553 19.7399V33.0551" stroke={stroke} strokeWidth={4} strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.6307 63.0145C48.9845 63.0145 54.946 57.053 54.946 49.6992C54.946 42.3454 48.9845 36.3839 41.6307 36.3839C34.2769 36.3839 28.3154 42.3454 28.3154 49.6992C28.3154 57.053 34.2769 63.0145 41.6307 63.0145Z"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.6302 48.0348C40.711 48.0348 39.9658 48.78 39.9658 49.6992"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.2953 49.6992C43.2953 48.78 42.5501 48.0348 41.6309 48.0348"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.6309 51.3636C42.5501 51.3636 43.2953 50.6184 43.2953 49.6992"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.9658 49.6992C39.9658 50.6184 40.711 51.3636 41.6302 51.3636"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.9168 63.0147C82.2707 63.0147 88.2321 57.0533 88.2321 49.6994C88.2321 42.3456 82.2707 36.3842 74.9168 36.3842C67.563 36.3842 61.6016 42.3456 61.6016 49.6994C61.6016 57.0533 67.563 63.0147 74.9168 63.0147Z"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.9164 48.0345C73.9971 48.0345 73.252 48.7797 73.252 49.699"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M76.5814 49.699C76.5814 48.7797 75.8362 48.0345 74.917 48.0345"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.917 51.3634C75.8362 51.3634 76.5814 50.6182 76.5814 49.699"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.252 49.699C73.252 50.6182 73.9971 51.3634 74.9164 51.3634"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.1094 61.8387L58.2765 73.0014L69.4435 61.8387"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.9066 72.9967V83.3693C84.9066 98.077 72.9837 110 58.2761 110C43.5684 110 31.6455 98.077 31.6455 83.3693V72.9967"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.904 57.2272C89.8394 56.7293 93.8001 57.9363 96.7889 60.5444C99.7777 63.1525 101.51 66.9133 101.549 70.8798V80.0452C101.488 86.5457 98.6964 92.7208 93.8574 97.0618C89.0183 101.403 82.5774 103.51 76.1084 102.868"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.1217 56.406C26.2293 56.0861 22.3806 57.4093 19.5078 60.0552C16.6351 62.7011 15.0005 66.4283 15 70.3338V79.6545C14.9987 86.2078 17.7564 92.4589 22.5974 96.8759C27.4384 101.293 33.9153 103.468 40.4411 102.867"
      stroke={stroke}
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GraduateOwlIcon;
